import { defineComponent as _defineComponent } from 'vue'
import { Offer } from '@/@types/graphql-types';
import { ClickoutUrl } from '@/helpers/clickout-helper';
import { useUserStore } from '@/helpers/composables/useStores';
import { SnowplowClickoutContextGraphql, SnowplowContext, SnowplowPackageContext } from '@/helpers/tracking/providers';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { TitleDetailsNode } from '@/interfaces/title-details-graphql';
import { OfferPresentationType } from '@/interfaces/titles';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BuyBoxBundle',
  props: {
    title: null,
    offer: null,
    additionalContexts: { default: () => [] }
  },
  setup(__props: any) {

const props = __props as { title: TitleDetailsNode, offer: Offer, additionalContexts: SnowplowContext[] }



const { buyboxPresentationType } = useUserStore();

const icons = ['/icon/207360008/s100/netflix.{format}'];
const imageScaler = JW_CONFIG.IMAGESCALER_URL;
const bundleURL = 'https://www.awin1.com/awclick.php?gid=466322&mid=11005&awinaffid=400165&linkid=3414019&clickref=';

const property = computed(() => {
	if (buyboxPresentationType.value === null) return OfferPresentationType._4K; //NOTE: for tracking purposes
	return buyboxPresentationType.value;
});
const bundleLabelSuffix = computed(() => {
	switch (buyboxPresentationType.value) {
		case null:
			return '4k';
		case OfferPresentationType._4K:
			return '4k';
		case OfferPresentationType.HD:
			return 'HD';
		default:
			return '';
	}
});

const bundleOfferUrl = new ClickoutUrl({
	standardWebURL: bundleURL,
}).toString();

function clickOut() {
	let contexts: SnowplowContext[] = [];
	const clickoutContext = SnowplowClickoutContextGraphql.fromProviderOffer(props.offer);
	const packageContext = new SnowplowPackageContext(
		props.offer.package.packageId,
		props.offer.package.technicalName,
		'bundle'
	);
	contexts = [...props.additionalContexts, clickoutContext, packageContext];
	TrackingHelper.trackEvent(
		'clickout',
		{
			action: 'flatrate',
			label: 'Sky Go',
			property: property.value,
			value: 3,
		},
		contexts
	);
}

return { __sfc: true,props, buyboxPresentationType, icons, imageScaler, bundleURL, property, bundleLabelSuffix, bundleOfferUrl, clickOut }
}

})